

let oldTime, newTime, timer, Vue;
let lang = localStorage.getItem('locale')?localStorage.getItem('locale'):'zh'

function startTimer() {
    oldTime = new Date().getTime();
    if(!timer) {
        timer = window.setInterval(isTimeOut, 6000)
    }
    
    document.onclick = eventListen;
    document.onmousedown = eventListen;
    document.onmouseover = eventListen;
    document.onmousemove = eventListen;
    document.onmouseout = eventListen;
    document.onkeydown = eventListen;
    document.onkeyup = eventListen;
}

function eventListen() {
    if(!timer)return
    oldTime = new Date().getTime();
}

function isTimeOut() {
    newTime = new Date().getTime();
    if(localStorage.getItem('user')&&JSON.parse(localStorage.getItem('user')).accountNo) {
        if(newTime - oldTime > 60*60*1000) {
            console.log('登录超时，请重新登录')
            clearInterval(timer); // 清楚定时器
            dialog(); // 弹窗
        }
    } 
}

function dialog() {
    localStorage.removeItem('user')
    Vue.$vs.dialog({
        // type: "flat",
        color: "danger",
        title: lang=='zh'?"登录":"Login",
        text: lang=='zh'?"登录已超时, 请重新登录":"Login has timed out. Please log in again",
        acceptText: lang=='zh'?"确定":'confirm',
        // cancelText: '',
        accept: () => {
            timer = window.setInterval(isTimeOut, 1000)
            location.href = '/#/pages/landing';
        }
    });
}

let outTime  = {}
outTime.install = function(vue) {
    Vue = new vue();
    startTimer()
}

export default outTime